

<section class="f-img h-screen py-36  justify-center relative overflow-hidden bg-no-repeat bg-center bg-cover">

  <div class="absolute inset-0 bg-gradient-to-b from-[transparent] to-earth-try"></div>

  <section class="absolute top-0 py-4 md:py-16 px-4 md:px-48 overflow-hidden bg-no-repeat bg-center bg-cover w-full">
    <div class="float-left text-left">
      <h3 class="text-earth-dark">MUDICO</h3>
      <span class="text-earth-dark">Multi Disciplinair Centrum voor Ontwikkeling</span>
    </div>

    <div class="hidden md:block float-left md:float-right text-left md:text-right socials px-0 md:px-2 py-4 md:py-2">
      <ul class="list-none text-center">
        <li class="inline"><a href="https://www.facebook.com/mudico1" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try text-xl md:text-md"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
        <li class="inline"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try ml-2 text-xl md:text-md"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
      </ul>
    </div>
  </section>

  <section class="absolute bottom-0 p-4 w-full">
    <div class="block md:hidden text-center socials px-0 md:px-2 py-4 md:py-2">
      <ul class="list-none text-center">
        <li class="inline"><a href="https://www.facebook.com/mudico1" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try text-xl md:text-md"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
        <li class="inline"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank" class="btn btn-icon btn-lg md:btn-sm border-2 text-earth-dark border-earth-dark rounded-md hover:bg-earth-try ml-2 text-xl md:text-md"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
      </ul>
    </div>

    <div class="text-center">
      <p class="mb-0 font-medium text-earth-common/70">© {{ year }} MuDiCO</p>
    </div>
  </section>

  <div class="container px-0 mx-0 pl-4 md:pl-48 relative z-3">
      <div class="grid grid-cols-1">
          <div class="flex flex-col min-h-screen justify-left md:px-0 py-0 px-4">

              <div class="title-heading text-left md:text-left my-0 md:my-8 pt-0 md:pt-16">
                  <h1 class="text-earth-dark mt-8 md:mt-32 mb-6 md:text-7xl text-3xl font-bold">Nog eventjes geduld!</h1>
                  <p class="text-earth-dark/80 text-2xl max-w-xl">Onze nieuwe website komt er snel aan.</p>
                  <p class="text-earth-dark/80 text-2xl max-w-xl mt-12 underline"><a [routerLink]="['/contact-underconstruction']" routerLinkActive="router-link-active" >Contacteer ons</a></p>
              </div>
          </div>
      </div>
  </div>
</section>
